module.exports = __webpack_public_path__ + "static/media/LearnCreatorStepCustomize.aefecd46.jpg";